import { render, staticRenderFns } from "./PrintAcrylicLabel.vue?vue&type=template&id=5bace4d8&scoped=true&"
import script from "./PrintAcrylicLabel.vue?vue&type=script&lang=js&"
export * from "./PrintAcrylicLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bace4d8",
  null
  
)

export default component.exports